"use client";
import React from "react";
import PrivacyCustomHeading from "../other/common/PrivacyCustomHeading";
import { PRIVACY_POLICY_LIST } from "../../utils/other-component";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="max-w-[768px] mx-auto px-4 py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        {PRIVACY_POLICY_LIST.map((section, index) => (
          <div key={index} className="mb-10">
            <PrivacyCustomHeading text={section.heading} myClass="mb-[15px]" />

            {/* Description paragraph if exists */}
            {section.description && (
              <p className="text-[#5E5C5C] font-normal my-6">
                {section.description}
              </p>
            )}

            {/* For normal text */}
            {section.type === "normal" && (
              <div className="text-[#5E5C5C] font-normal ">
                {section.points.map((point, idx) => (
                  <p key={idx} className="mt-4">
                    {point.includes("support@makewayindia.com") ? (
                      <a
                        href="mailto:support@makewayindia.com"
                        className="text-blue-600  hover:text-blue-800 transition "
                      >
                        <span className="text-[#010101] font-bold text-base ">
                          Email:
                        </span>{" "}
                        <span className="underline">
                          support@makewayindia.com
                        </span>
                      </a>
                    ) : (
                      point
                    )}
                  </p>
                ))}
              </div>
            )}

            {/* For numbered list */}
            {section.type === "numbered" && (
              <ol className="list-decimal list-inside space-y-4 text-[#5E5C5C] font-normal">
                {section.points.map((point, idx) => {
                  const splitIndex = point.indexOf(":");
                  const hasColon = splitIndex !== -1;

                  return (
                    <li key={idx}>
                      {hasColon ? (
                        <>
                          <span className="font-semibold text-[#010101]">
                            {point.slice(0, splitIndex + 1)}
                          </span>{" "}
                          {point.slice(splitIndex + 1)}
                        </>
                      ) : (
                        <span className="font-semibold text-[#010101]">
                          {point}
                        </span>
                      )}
                    </li>
                  );
                })}
              </ol>
            )}

            {/* For mixed type (normal + numbered) */}
            {section.type === "mixed" && (
              <div className="space-y-10 text-[#5E5C5C]">
                {/* First point as paragraph */}
                <p className="font-normal">{section.points[0]}</p>

                {/* Remaining points as numbered list */}
                <ol className="list-decimal list-inside space-y-4 mt-4 font-normal">
                  {section.points.slice(1).map((point, idx) => {
                    const splitIndex = point.indexOf(":");
                    const hasColon = splitIndex !== -1;

                    return (
                      <li className="font-bold text-[#010101]" key={idx}>
                        {hasColon ? (
                          <>
                            <span className="font-bold !text-[#010101]">
                              {point.slice(0, splitIndex + 1)}
                            </span>{" "}
                            {point.slice(splitIndex + 1)}
                          </>
                        ) : (
                          <span className="font-bold !text-[#010101]">
                            {point}
                          </span>
                        )}
                      </li>
                    );
                  })}
                </ol>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="h-[200px] max-lg:h-[100px]"></div>
    </>
  );
};

export default PrivacyPolicy;
